
import { downloadExportFile } from "@/helpers";
import * as selectOptions from "@/helpers/selectOptions";
import { capitalize, omit } from "lodash";
import Vue from "vue";
import { atlasPlatformMapActions } from "@/store/modules/atlasPlatform";
import { IAtlasPlatform } from "@/store/modules/atlasPlatform/types";
export default Vue.extend({
  name: "exporter",
  props: {
    defaultType: {
      type: String,
      required: false,
      default: ""
    },
    exportName: {
      type: String,
      required: false,
      default: ""
    },
    isLegacy: {
      type: Boolean,
      required: false,
      default: false
    },
    providedTypeFieldOptions: {
      type: Array,
      required: false
    }
  },
  data(): any {
    return {
      type: "",
      fields: [],
      selectedCompanyIds: [],
      selectedAtlasPlatformIds: [],
      atlasPlatforms: [] as IAtlasPlatform[],
      typeFieldOptions: {
        users: selectOptions.userExportFieldOptions,
        counties: selectOptions.countiesExportFieldOptions,
        policyChangeRequests:
          selectOptions.policyChangeRequestsExportFieldOptions,
        payPlanChangeRequests: selectOptions.billingRequestsExportFieldOptions,
        billingChangeRequests: selectOptions.billingRequestsExportFieldOptions,
        policySign: selectOptions.signedPoliciesExportFieldOptions,
        agentApplications: selectOptions.agentApplicationsExportFieldOptions,
        quotes: selectOptions.quotesExportFieldOptions,
        agencies: selectOptions.agenciesExportFieldOptions,
        endorsements: selectOptions.endorsementsExportFieldOptions,
        mortgages: selectOptions.mortgagesExportFieldOptions,
        quoteCountyValidation:
          selectOptions.countyValidationsExportFieldOptions,
        faqs: selectOptions.faqsExportFieldOptions,
        companies: selectOptions.companiesExportFieldOptions,
        transactions: selectOptions.transactionsExportFieldOptions
      },
      exportAll: false
    };
  },
  methods: {
    ...atlasPlatformMapActions(["getAtlasPlatforms"]),
    async exportCountiesActionHandler(): Promise<void> {
      let query = this.exportAll
        ? {}
        : this.$store.state.list_view_module["filterQuery"] || {};

      //To be removed after INF filter query fix
      if (query.submittedOn_dateFilter) {
        query = omit(query, "submittedOn_dateFilter");
      }
      if (query.createdOn_dateFilter) {
        query = omit(query, "createdOn_dateFilter");
      }
      if (query.modifiedOn_dateFilter) {
        query = omit(query, "modifiedOn_dateFilter");
      }
      if (this.defaultType === "claims") {
        query["isLegacy"] = this.isLegacy + "";
      }
      if (this.type === "users" && this.selectedCompanyIds.length > 0) {
        query = { ...query, companyIds__in: this.selectedCompanyIds };
      }
      if (this.type === "faqs" && this.selectedAtlasPlatformIds.length > 0) {
        query = {
          ...query,
          atlasPlatformIds__in: this.selectedAtlasPlatformIds
        };
      }
      downloadExportFile(
        {
          collection: this.type,
          query,
          fields: this.fields
        },
        `${this.exportName ||
          capitalize(this.type)} - ${new Date().toISOString()}`
      );

      this.$emit("exported");
    },
    handleExportAll($event: boolean) {
      if ($event) {
        this.fields = this.columnFields.map(
          ({ value }: { value: string }) => value
        );
      }
    },
    async fetchAtlasPlatforms(): Promise<void> {
      try {
        const data = await this.getAtlasPlatforms({});
        this.atlasPlatforms = data || [];
      } catch (error) {
        this.$bugSnagClient?.notify?.(error);
      }
    }
  },
  computed: {
    columnFields(): any {
      return this.type === "claims"
        ? this.providedTypeFieldOptions
        : this.typeFieldOptions[this.type];
    },
    companyOptions(): { label: string; value: string }[] {
      const initData = this.$store.state.auth["initData"] || {};
      const companies = initData.companies || [];
      return companies
        .map((company: any) => ({
          label: company.companyName,
          value: company._id
        }))
        .sort((a: any, b: any) => a.label.localeCompare(b.label));
    },
    atlasPlatformOptions(): { label: string; value: string }[] {
      return (this.atlasPlatforms as IAtlasPlatform[])
        .map((platform: IAtlasPlatform) => ({
          label: platform.name,
          value: platform._id
        }))
        .sort((a: any, b: any) => a.label.localeCompare(b.label));
    }
  },
  watch: {
    defaultType: {
      immediate: true,
      handler(val: string) {
        if (val.length > 0) {
          this.type = val;
          this.fields = this.columnFields.map((v: any) => v.value);
          if (val === "faqs") {
            this.fetchAtlasPlatforms();
          }
        }
      }
    },
    type(val: string) {
      if (val === "faqs" && this.atlasPlatforms.length === 0) {
        this.fetchAtlasPlatforms();
      }
    }
  }
});
